import React, { useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCurrentProvider from "../hooks/useCurrentProvider";

interface clinic {
  clinicCode: string;
}

const CreateProvider: React.FC<clinic> = ({ clinicCode }) => {
  const user = useCurrentProvider();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    clinicCode: clinicCode,
    region: "",
    npi: "",
    phone: "",
    licenses: { licenseNumber: "", licenseState: "" },
  });

  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "licenseNumber" || name === "licenseState") {
      setFormData((prev) => ({
        ...prev,
        licenses: { ...prev.licenses, [name]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setError("Please enter a valid email.");
      return;
    }
    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setError(null);
    setMessage(null);

    // validate NPI before creating provider
    try {
      await axios.get(
        `${SERVER_URL}/api/provider/validate-npi/${formData.npi}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    } catch {
      toast.error("Invalid NPI number");
      return;
    }

    try {
      const response = await axios.post(
        `${SERVER_URL}/api/auth/provider/signup`,
        {
          ...formData,
          passwordHash: formData.password,
        }
      );
      if (response.status === 201) {
        setMessage("Provider registered successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          clinicCode: clinicCode,
          region: "",
          npi: "",
          phone: "",
          licenses: {
            licenseNumber: "",
            licenseState: "",
          },
        });
      }
    } catch (err: any) {
      console.error("Signup error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Signup failed.");
    }
  };

  return (
    <div className="clinic-container">
      <h2>Create Provider</h2>
      {message && (
        <p className="message" style={{ color: "green" }}>
          {message}
        </p>
      )}
      {error && (
        <p className="message" style={{ color: "red" }}>
          {error}
        </p>
      )}
      <form onSubmit={handleSubmit} className="clinic-form">
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          name="phone"
          placeholder="Phone"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password (min 6 chars)"
          value={formData.password}
          onChange={handleChange}
          required
          minLength={6}
        />
        <input
          type="text"
          name="npi"
          placeholder="NPI Number"
          value={formData.npi}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="region"
          placeholder="Region"
          value={formData.region}
          onChange={handleChange}
          required
        />
        <label
          style={{
            display: "flex",
            justifyContent: "flex-start",
            fontSize: "15px",
            fontStyle: "normal",
            color: "var(--primary-color)",
          }}
        >
          {" "}
          Clinic code:{" "}
        </label>
        <input
          type="text"
          name="clinicCode"
          placeholder="Clinic Code"
          value={formData.clinicCode}
          onChange={handleChange}
          required
        />
        <input
          name="licenseNumber"
          placeholder="License #"
          value={formData.licenses.licenseNumber}
          onChange={handleChange}
        />

        <input
          name="licenseState"
          placeholder="State (e.g., NY)"
          value={formData.licenses.licenseState}
          onChange={handleChange}
        />
        <button type="submit">Register Provider</button>
      </form>
    </div>
  );
};

export default CreateProvider;
